import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Grid, MenuItem, Select, TextField, Typography, Tooltip } from "@mui/material";
import AddNameBtn from "../FileuploadWithPreview/AddNameBtn";
import Instruction from "../QuestionInstructions/Instruction";
import MulitipleChoice from "../QuestionInstructions/MulitipleChoice";
import Checkbox from "../QuestionInstructions/Checkbox";
import note from '../../../src/assests/images/note-2.svg';
import Fileupload from "../FileuploadWithPreview/Fileupload";
import StarRating from "../QuestionInstructions/RatingScale";
import trash from '../../../src/assests/images/trash.svg';
import galleryadd from '../../../src/assests/images/gallery-add.svg';
import copy from '../../../src/assests/images/copy.svg';
import ImageUploadBanner from "../../pages/brands/ImageUploderBanner";
import Warning from "../../../src/assests/images/warning-2.svg";
import { SelectChangeEvent } from "@mui/material";
import ArrowDownCurve from '../../../src/assests/images/arrow-down-curve.svg'
import { useTaskContext } from "../store/AlltasksContext";
import { uploadimagetask } from "../../pages/create-task/api";
import { getToken } from "../../utils/utils";



interface InstructionItem {
  id: number;
  value: string;
}


interface SectionData {
  value?: string;
  id: number;
  initialName: string;
  placeholder: string;
  markerImage: string;
  typographyText: string;
  textValue: string;
  textValue_hi: string;
  language: string;
    main_question_id: string;
  iconimage: string;
  mainplaceholder: string;
  selectValue: string;
  smallquestionsimage: string[];
  optionsslectedvalue: string | null;
  finalcorr?: string;
  correcthint: string;
  correcthint_hi: string;
  idid1: number;
  taskinstructions: { id: number; value: string; image: string }[];
  taskimage: string;
  test245: string;
  dropdownOptions: { id: number; label: string; value: string }[];
  instructions: { id: number; value: string; value_hi: string; smallimage: string; bigimage: string }[];
  Multiples: { id: number; value: string; value_hi: string; checkvalue: string; smallimage: string; bigimage: string; ismatch?: boolean }[];
  Checkboxes: { id: number; value: string; checked: boolean }[];
  rating: { initialStars: number; maxStarsOptions: number[] };
}


type SectionsProps = {
  sectionsData: SectionData[];
  setSectionsData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  onDeleteSection: (id: number) => void;
  combinedqtnclass?: string;
  seteducationalData: React.Dispatch<React.SetStateAction<SectionData[]>>;
  educationalData: SectionData[];
  lang: {
    instruction: string;
    addInstruction: string,
    imgageGifVideo: string;
    uploadImage: string;
    pageLabel: string;
    uploadText: string;
    uploadSize: string;
    option: string;
    questionPoint: string;
    writeHintCorrectOption: string,
    addOptions: string,
    selectCorrectOptionHint: string,
  };

};

interface QuestionsBoxProps {
  currentLang: any;

}
const QuestionsBox: React.FC<SectionsProps> = ({ lang, sectionsData, setSectionsData, seteducationalData, educationalData, combinedqtnclass = "qtnbox", onDeleteSection
  // state,setState
}) => {


  const [mainoptions, setmainoptions] = useState("");
  const { selectedmcq22,setSelectedmcq22,Tabname, setTabname, currentData, setCurrentData, activeStep, setCorrectHintHiArray, correctHintHiArray, correctHintArray, setCorrectHintArray, textValueHiData, setTextValueHiData, textValueData, setTextValueData, test22Value, setTest22Value, uploadedImages, setUploadedImages, step1data, setstep1data, step1data2, setstep1data2, allinone, selectedmcq, setSelectedmcq, longDescriptions, setLongDescriptions, longDescriptionsHi, setLongDescriptionsHi, setTextValueData44, textValueData44 ,  textValueDatadefault, setTextValueDatadefault, textValueDatadefaulthindi, setTextValueDatadefaulthindi,step1data2default, setstep1data2default} = useTaskContext();
  console.log(Tabname, "cccccccccccccccccccc")
  console.log(textValueData44, "uuuu")
  console.log(currentData, "dsssssssssssssss",allinone)



  const isEducational = sectionsData === educationalData;
  // const [currentData, setCurrentData] = useMemo(() => {
  //   return Tabname === "Educational task"
  //     ? [educationalData, seteducationalData]
  //     : [sectionsData, setSectionsData];
  // }, [Tabname, sectionsData, setSectionsData, educationalData, seteducationalData]);
  const [selectedSectionIds, setSelectedSectionIds] = useState<number[]>([]);
  //  const [selectedmcq, setSelectedmcq] = useState('');
  // value reset for selecting different options Start //
  const [currentMultipleChoiceId, setCurrentMultipleChoiceId] = useState<number | null>(null);
  console.log(allinone, "allinoneallinone")
  const [activeLanguage, setActiveLanguage] = React.useState<"en" | "hi" | "mr">("en");
const handleSelectChange = (event: SelectChangeEvent<string>, id: number) => {
  const value = event.target.value;

  setSelectedmcq22(prev => ({ ...prev, [id]: value }));
  setmainoptions(value);

  setCurrentData((prevData: any[]) =>
    prevData.map(section => {
      if (section.id === id) {
        // Initialize Checkboxes if "checkbox" is selected
        const updatedCheckboxes = value === "checkbox" && section.Checkboxes.length === 0
          ? [{ id: 1, value: "", checked: false, idid: id }]
          : section.Checkboxes;

        return {
          ...section,
          selectValue: value,
          Checkboxes: updatedCheckboxes,
        };
      }
      return section;
    })
  );

  if (value === "multiplechoice") {
    setCurrentMultipleChoiceId(id);
  } else {
    setCurrentMultipleChoiceId(null);
  }
};


//   const handleSelectChange = (event: SelectChangeEvent<string>, id: number) => {
//     const value = event.target.value;

//   (setSelectedmcq22 as React.Dispatch<React.SetStateAction<{ [key: number]: string }>>)((prev) => ({
//   ...prev,
//   [id]: value,
// }));


//     setSelectedmcq(value);
//     setmainoptions(value);
//     setCurrentData((prevData: any[]) =>
//       prevData.map((section) => {
//         if (section.id === id) {
//           return {
//             ...section,
//             selectValue: value,
//             textValue: value === "instructions" ? section.textValue : "",
//             instructions:
//               value === "instructions"
//                 ? section.instructions
//                 : section.instructions.length > 0
//                   ? section.instructions
//                   : [{ id: 1, value: "", smallimage: "", bigimage: "" }],
//             Multiples:
//               value === "multiplechoice"
//                 ? [{ id: 1, value: "", value_hi: "", checkvalue: "", smallimage: "", bigimage: "" }]
//                 : section.Multiples.length > 0
//                   ? section.Multiples
//                   : [{ id: 1, value: "", value_hi: "", checkvalue: "", smallimage: "", bigimage: "" }],
//             Checkboxes:
//               value === "checkbox"
//                 ? section.Checkboxes.length > 0
//                   ? section.Checkboxes
//                   : [{ id: 1, value: "", checked: false, idid: id }]
//                 : section.Checkboxes.length > 0
//                   ? section.Checkboxes
//                   : [{ id: 1, value: "", checked: false, idid: id }],
//             rating:
//               value === "ratings"
//                 ? section.rating
//                 : section.rating || { initialStars: 0, maxStarsOptions: [5, 6, 7, 8, 9, 10] },
//           };
//         }
//         return section;
//       })
//     );
//     if (value === "multiplechoice") {
//       setCurrentMultipleChoiceId(id);
//     } else {
//       setCurrentMultipleChoiceId(null);
//     }
//   };
  console.log(selectedmcq22, "selectedmcq22selectedmcq22222")
  // value reset for selecting different options End //
  console.log(currentMultipleChoiceId, "selectedSectionIdsdddddddddd")
  console.log(selectedmcq, "selectedmcq==999")
  console.log(mainoptions, "55552222222222222255555")

  // DND Start //
  // const [longDescriptions, setLongDescriptions] = useState<{ [key: string]: string }>({});
  const clickedItem = useRef<number>(0);
  const cleckedItemHolder = useRef<number>(0);
  console.log(longDescriptions, "vbbbbbbbb")
  function handleSort() {
    const dragList = [...currentData];
    const temp = dragList[clickedItem.current];
    dragList[clickedItem.current] = dragList[cleckedItemHolder.current];
    dragList[cleckedItemHolder.current] = temp;
    setCurrentData(dragList);
  }
  console.log(sectionsData, "erfmmkkkkkkkk");

  const scrollSpeed = 10;
  const [test22, settest22] = useState("");
  const handleDragOver = (e: React.DragEvent<HTMLSpanElement>) => {
    e.preventDefault();

    const scrollThreshold = 100; // Distance from the edge to trigger scrolling
    const scrollSpeed = 20; // Number of pixels to scroll per step
    const { clientY } = e; // Cursor's Y position in the viewport
    const { innerHeight } = window; // Viewport height
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // Current scroll position
    const scrollHeight = document.documentElement.scrollHeight; // Total scrollable height

    if (clientY < scrollThreshold && scrollTop > 0) {
      // Near the top, scroll up
      window.scrollBy({ top: -scrollSpeed, behavior: "smooth" });
    } else if (clientY > innerHeight - scrollThreshold && scrollTop + innerHeight < scrollHeight) {
      // Near the bottom, scroll down
      window.scrollBy({ top: scrollSpeed, behavior: "smooth" });
    }
  };

  // DND Ends //

  // const handleDelete = (sectionId: number) => { setLongDescriptions((prev) => {
  //     const updated = { ...prev };
  //     delete updated[sectionId];
  //     return updated;
  //   });setCurrentData((prevData: any[]) => prevData.filter((data) => data.id !== sectionId)); };


  const handleDelete = (sectionId: number) => {
    // Remove from longDescriptions (English)
    setLongDescriptions((prev) => {
      const updated = { ...prev };
      delete updated[sectionId];
      return updated;
    });

    // Remove from longDescriptionsHi (Hindi)
    setLongDescriptionsHi((prev) => {
      const updated = { ...prev };
      delete updated[sectionId];
      return updated;
    });

    // Remove from currentData
    setCurrentData((prevData: any[]) => prevData.filter((data) => data.id !== sectionId));
  };

  const handleCopy = (textToCopy: string) => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => { alert('Copied to clipboard!'); })
      .catch((err) => { console.error('Failed to copy text: ', err); });
  };


  // const [step1data, setstep1data] = useState<any[]>([]);
  const updateSectionsData = (sectionId: number, updatedMultiples: any) => {
    if (activeStep === 1) {
      setstep1data((prevSections: any[]) => {
        const updatedSections = prevSections.map((section) => {
          if (section.id === sectionId) {
            const isSame = JSON.stringify(section.Multiples) === JSON.stringify(updatedMultiples);
            if (!isSame) {
              return { ...section, Multiples: updatedMultiples };
            }
          }
          return section;
        });

        // If sectionId doesn't exist in prevSections, add it
        const exists = updatedSections.some(section => section.id === sectionId);
        if (!exists) {
          updatedSections.push({ id: sectionId, Multiples: updatedMultiples });
        }

        console.log(updatedMultiples, "✅ updatedMultiples being set (Step 1)");
        console.log(updatedSections, "✅ updated step1data");

        return updatedSections;
      });
    } else if (activeStep === 2) {
      setstep1data2((prevSections: any[]) => {
        const updatedSections = prevSections.map((section) => {
          if (section.id === sectionId) {
            const isSame = JSON.stringify(section.Multiples) === JSON.stringify(updatedMultiples);
            if (!isSame) {
              return { ...section, Multiples: updatedMultiples };
            }
          }
          return section;
        });

        // If sectionId doesn't exist in prevSections, add it
        const exists = updatedSections.some(section => section.id === sectionId);
        if (!exists) {
          updatedSections.push({ id: sectionId, Multiples: updatedMultiples });
        }

        console.log(updatedMultiples, "✅ updatedMultiples being set (Step 2)");
        console.log(updatedSections, "✅ updated step1data2");

        return updatedSections;
      });
    }
  };

  console.log(activeStep, "activeStepactiveStepuuuu")
  console.log(step1data2, "step1datastep1data")


  const updateSectionsData1 = (sectionId: number, index: number, text: string) => {
    if (activeStep === 1) {
      // 🟢 Get the old English value before updating
      const oldItem = correctHintArray.find((item) => item.id === sectionId && item.index === index);
      const oldValue = oldItem ? oldItem.value : "";

      // 🟢 Update English array
      setCorrectHintArray((prev) => {
        const filtered = prev.filter(
          (item) => !(item.id === sectionId && item.index === index)
        );
        return [...filtered, { id: sectionId, index, value: text, hint_id: "" }];
      });

      // 🟢 Auto-sync full value into Hindi array (not partial)
      setCorrectHintHiArray((prev) => {
        const filtered = prev.filter(
          (item) => !(item.id === sectionId && item.index === index)
        );

        // Check if Hindi already has manual value
        const existing = prev.find(
          (item) => item.id === sectionId && item.index === index
        );

        // Only overwrite Hindi if it’s empty or matches the old English
        if (!existing || existing.value.trim() === "" || existing.value === oldValue) {
          return [...filtered, { id: sectionId, index, value: text, hint_id: "" }];
        }

        // Otherwise, keep existing Hindi text (user manually changed it)
        return prev;
      });
    } else if (activeStep === 2) {
      // 🟢 Update Hindi array manually
      setCorrectHintHiArray((prev) => {
        const filtered = prev.filter(
          (item) => !(item.id === sectionId && item.index === index)
        );
        return [...filtered, { id: sectionId, index, value: text, hint_id: "" }];
      });
    }
  };









  const updateSectionsData345 = (sectionId: number, test22: string) => {
    console.log(test22, "test224444444")
    console.log(sectionId, "sectionIdsectionIdsectionId22")
    setTest22Value(test22);

    // setCurrentData((prevSections: any[]) =>
    //   prevSections.map((section) =>
    //     section.id === sectionId ? { ...section, test245  : test22 } : section
    //   )
    // );
  };
  console.log(test22Value, "test22Value77777777777")
  const [selectedSectionId, setSelectedSectionId] = useState<number | null>(null);

  // Update the state when multiple choice is selected
  useEffect(() => {
    const selectedSection = sectionsData.find(section => section.selectValue === "multiplechoice");
    if (selectedSection) {
      setSelectedSectionId(selectedSection.id);
    }
  }, [sectionsData]);
  const [descriptions, setDescriptions] = useState<Record<string, string>>({});
  console.log(selectedSectionId, "selectedSectionIdsssssss")
  console.log(test22, "ccccccsssssssssssss")
  console.log(currentData, "sectionsDatasssssssssssssss")


  const [uploadedImage22, setuploadedImage11] = useState<string | undefined>(undefined);

  const token = getToken();
  // const [uploadedImages, setUploadedImages] = useState<{ [key: number]: string }>({});
console.log(uploadedImages, "uploadedImagesuploadedImages")
  const handleUpload = async (file: File | null, id: number) => {
    if (!file) return; // Ensure file is not null
    console.log(`Selected file for IDcdddd ${id}:`, file);

    const formData = new FormData();
    formData.append("answer", file); // Append the single file

    try {
      const response = await uploadimagetask(formData, token);
      const uploadedFileName = response.data.answer


      const imageUrl = response.data.answer



      setUploadedImages((prev) => ({
        ...prev, // Spread previous state
        [id]: imageUrl, // Store image URL for the corresponding ID
      }));
      setCurrentData((prevData: any[]) =>
        prevData.map((item) =>
          item.id === id
            ? {
              ...item,
              smallquestionsimage: [...(item.smallquestionsimage || []), uploadedFileName]
            }
            : item
        )
      );


    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  console.log(uploadedImages, "uploadedImagesuploadedImageswwwwwwwww")
  console.log(allinone, "allinone777777788")
  useEffect(() => {
    if (allinone && allinone.length > 0) {
      const mappedData = allinone.map((question: any) => {
        return {
          id: question.question_no, // match with your section.id
           main_question_id: question.question_id,
          Multiples: question.options.map((option: any, index: number) => ({
            id: option.option_id || index + 1,
            value: option.option_value_en || "",
            value_hi: option.option_value_hi || "",
            checkvalue: option.correct_option, // "1" or "0"
            smallimage: option.option_small_img || "",
            bigimage: option.option_big_img || "",
            ismatch: option.correct_option === "1" // boolean
          }))
        };
      });

      setstep1data2(mappedData);
      console.log("✅ Prefilled step1data2:", mappedData);
    }
  }, [allinone, setstep1data2]);

  console.log(step1data2, "step1data2885555565666")
  const handleRemove = (id: number) => {
    console.log(`File removed for ID: ${id}`);
    setUploadedImages((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });

    setCurrentData((prevData: any[]) =>
      prevData.map((item) =>
        item.id === id
          ? {
            ...item,
            smallquestionsimage: [] // or remove the specific image name if needed
          }
          : item
      )
    );
  };


  // const [textValueData, setTextValueData] = useState<{ id: number; value: string }[]>([]);
  // const [textValueHiData, setTextValueHiData] = useState<{ id: number; value: string }[]>([]);
  const updateValueById = (
    data: { id: number; value: string }[],
    id: number,
    newValue: string
  ) => {
    const existing = data.find((item) => item.id === id);
    if (existing) {
      return data.map((item) => (item.id === id ? { ...item, value: newValue } : item));
    } else {
      return [...data, { id, value: newValue }];
    }
  };


  const updateValueById1 = (
    data: { id: number; value: string }[],
    id: number,
    newValue: string
  ) => {
    const existing = data.find((item) => item.id === id);
    if (existing) {
      return data.map((item) => (item.id === id ? { ...item, value: newValue } : item));
    } else {
      return [...data, { id, value: newValue }];
    }
  };

  // useEffect(() => {
  //   if (allinone && allinone.length > 0) {
  //     // Prefill step1data2 with options
  //     const mappedData = allinone.map((question: any) => ({
  //       id: question.question_no,
  //       Multiples: question.options.map((option: any, index: number) => ({
  //         id: option.option_id || index + 1,
  //         value: option.option_value_en || "",
  //         value_hi: option.option_value_hi || "",
  //         checkvalue: option.correct_option,
  //         smallimage: option.option_small_img || "",
  //         bigimage: option.option_big_img || "",
  //         ismatch: option.correct_option === "1",
  //       })),
  //     }));
  //     setstep1data2(mappedData);

  //     // Initialize hint arrays
  //     // const newCorrectHintArray: { id: number; index: number; value: string }[] = [];
  //     // const newCorrectHintHiArray: { id: number; index: number; value: string }[] = [];

  //     // allinone.forEach((question: any) => {
  //     //   const questionId = question.question_no;
  //     //   const steps = question.hint?.steps || [];

  //     //   // Process hint steps
  //     //   steps.forEach((step: any, index: number) => {
  //     //     if (step.step_text_en) {
  //     //       newCorrectHintArray.push({
  //     //         id: questionId,
  //     //         index,
  //     //         value: step.step_text_en,
  //     //       });
  //     //     }
  //     //     if (step.step_text_hi) {
  //     //       newCorrectHintHiArray.push({
  //     //         id: questionId,
  //     //         index,
  //     //         value: step.step_text_hi,
  //     //       });
  //     //     }
  //     //   });

  //     //   // Process hint_type and content_type_en/hi
  //     //   if (question.hint_type) {
  //     //     newCorrectHintArray.push({
  //     //       id: questionId,
  //     //       index: 0,
  //     //       value: question.hint_type,
  //     //     });
  //     //   }
  //     //   if (question.content_type_en) {
  //     //     newCorrectHintHiArray.push({
  //     //       id: questionId,
  //     //       index: 0,
  //     //       value: question.content_type_en,
  //     //     });
  //     //   }
  //     // });

  //     // // Merge with provided hint arrays
  //     // const providedCorrectHintArray = [{ id: 1, index: 0, value: "ff" }];
  //     // const providedCorrectHintHiArray = [{ id: 2, index: 1, value: "s" }];

  //     // const mergedCorrectHintArray = [
  //     //   ...providedCorrectHintArray.filter(
  //     //     (provided) =>
  //     //       !newCorrectHintArray.some(
  //     //         (newHint) => newHint.id === provided.id && newHint.index === provided.index
  //     //       )
  //     //   ),
  //     //   ...newCorrectHintArray,
  //     // ];

  //     // const mergedCorrectHintHiArray = [
  //     //   ...providedCorrectHintHiArray.filter(
  //     //     (provided) =>
  //     //       !newCorrectHintHiArray.some(
  //     //         (newHint) => newHint.id === provided.id && newHint.index === provided.index
  //     //       )
  //     //   ),
  //     //   ...newCorrectHintHiArray,
  //     // ];

  //     // // Update state based on activeStep
  //     // if (activeStep === 1) {
  //     //   setCorrectHintArray(mergedCorrectHintArray);
  //     // } else if (activeStep === 2) {
  //     //   setCorrectHintHiArray(mergedCorrectHintHiArray);
  //     // }
  //   }
  // }, [allinone, activeStep, setCorrectHintArray, setCorrectHintHiArray, setstep1data2]);

  console.log(textValueData, "textValueDatassssss", textValueHiData, "textValueHiDatakkkkk")
  console.log(currentData, "sectionsDatassssssss55555555555")
  console.log(test22Value, "test22Valuemmmmmmmmmmm")
  console.log()
  // useEffect(() => {
  //   if (allinone && allinone.length > 0) {
  //     const newCorrectHintArray = allinone.map((question: any) => ({
  //       id: question.question_no,
  //       index: 0, // Default index, as per your example
  //       value: question.hint?.content_type_en || "",
  //     }));

  //     const newCorrectHintHiArray = allinone.map((question: any) => ({
  //       id: question.question_no,
  //       index: 0, // Default index, as per your example
  //       value: question.hint?.content_type_hi || "",
  //     }));
  //     console.log(newCorrectHintArray, newCorrectHintHiArray, "dddddddddwwwwwwwwwwwwwww", allinone)
  //     // Update correctHintArray, avoiding overwriting existing user input
  //     setCorrectHintArray((prev) => {
  //       const updated = [...prev];
  //       newCorrectHintArray.forEach((newItem) => {
  //         const exists = updated.some((item) => item.id === newItem.id);
  //         if (!exists) {
  //           updated.push(newItem);
  //         }
  //       });
  //       return updated;
  //     });

  //     // Update correctHintHiArray, avoiding overwriting existing user input
  //     setCorrectHintHiArray((prev) => {
  //       const updated = [...prev];
  //       newCorrectHintHiArray.forEach((newItem) => {
  //         const exists = updated.some((item) => item.id === newItem.id);
  //         if (!exists) {
  //           updated.push(newItem);
  //         }
  //       });
  //       return updated;
  //     });
  //   }
  // }, [allinone, setCorrectHintArray, setCorrectHintHiArray]);

  // const handleLongChange = (id: string, value: string) => {
  const handleLongChange = (id: string, value: string) => {
    if (activeStep === 1) {
      // Update English descriptions
      setLongDescriptions((prev) => ({
        ...prev,
        [id]: value,
      }));
      setCurrentData((prev: any[]) =>
        prev.map((s) =>
          s.id === id
            ? {
              ...s,
              longShortDescription: {
                ...(s.longShortDescription ?? {}),
                long: value,
              },
            }
            : s
        )
      );
    } else if (activeStep === 2) {
      // Update Hindi descriptions
      setLongDescriptionsHi((prev) => ({
        ...prev,
        [id]: value,
      }));
      setCurrentData((prev: any[]) =>
        prev.map((s) =>
          s.id === id
            ? {
              ...s,
              longShortDescription: {
                ...(s.longShortDescription ?? {}),
                long_hi: value, // Store Hindi description
              },
            }
            : s
        )
      );
    }
  };

  //    setLongDescriptions((prev) => ({
  //       ...prev,
  //       [id]: value
  //     }));

  //   setCurrentData((prev: any[]) =>
  //     prev.map((s) =>
  //       s.id === id
  //         ? {
  //             ...s,
  //             longShortDescription: {
  //               ...(s.longShortDescription ?? {}),
  //               long: value,
  //             },
  //           }
  //         : s
  //     )
  //   );
  // };

  console.log(longDescriptions, "descriptionsoodsfoodso")

  console.log(correctHintArray, "correctHintArraycorrectHintArray", correctHintHiArray, "correctHintHiArraycorrectHintHiArray", allinone)
  console.log(textValueData44, "textValueData44888888888")
  console.log(textValueData, "textValueData332211")
useEffect(() => {
  // Fill empty values in English data
  setTextValueData(prev =>
    prev.map(item => {
      const defaultItem = textValueDatadefault.find(d => d.id === item.id);
      return {
        ...item,
        value: item.value || (defaultItem ? defaultItem.value : ""),
      };
    })
  );

  // Fill empty values in Hindi data
  setTextValueHiData(prev =>
    prev.map(item => {
      const defaultItem = textValueDatadefaulthindi.find(d => d.id === item.id);
      return {
        ...item,
        value: item.value || (defaultItem ? defaultItem.value : ""),
      };
    })
  );
}, [textValueDatadefault, textValueDatadefaulthindi]);

console.log(currentData, "currentDatasssssssss")
  return (
    <Box>

      {(Tabname === "Dotcode Scanning Task" || Tabname === "डॉटकोड स्कैनिंग कार्य") ? (
        <Box>
          {currentData.map((section: any, index: any) => (
            <Grid className={combinedqtnclass} key={section.id} container spacing={1}>
              <Grid item md={11}>
                <Box sx={{ padding: "24px", backgroundColor: "#FFF", borderRadius: "16px", marginBottom: "24px", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #F1F2F3", paddingBottom: "18px", marginBottom: "18px", }}>
                    <AddNameBtn
                      initialName={section.initialName}
                      placeholder={section.placeholder}
                      onNameChange={(name: string) => console.log(`Name changed for Section ${section.id}:`, name)}
                      markerImage={section.markerImage}
                    />
                    <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#282829" }}> {section.typographyText} </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "18px", justifyContent: "end", marginBottom: "18px", }}>


                    <TextField
  value={
    activeStep === 1
      ? textValueData.find((item) => item.id === section.id)?.value || ""
      : textValueHiData.find((item) => item.id === section.id)?.value || ""
  }
  onChange={(e) => {
    const newValue = e.target.value;
    if (activeStep === 1) {
      const oldValue = textValueData.find((item) => item.id === section.id)?.value || "";
      setTextValueData((prev) => updateValueById(prev, section.id, newValue));
      const existingHi = textValueHiData.find((item) => item.id === section.id);
      if (!existingHi || existingHi.value.trim() === "" || existingHi.value === oldValue) {
        setTextValueHiData((prev) => updateValueById(prev, section.id, newValue));
      }
    } else if (activeStep === 2) {
      setTextValueHiData((prev) => updateValueById(prev, section.id, newValue));
    }
  }}
  placeholder={section.mainplaceholder}
  sx={{ backgroundColor: "#F9FBFC" }}
  variant="outlined"
/>

                    {/* <Box sx={{ width: "200px" }}
                    >
                      <TextField

                        variant="outlined"
                        placeholder="Enter the Points"

                      />
                    </Box> */}
                    <Box sx={{ margin: "0 0 0 0px" }}>
                      <TextField
                        sx={{
                          ".MuiInputBase-input": {
                            padding: "16px",
                            color: "#171717",
                            fontSize: "16px",
                            fontWeight: "500",
                            background: "#F9FBFC",
                            borderRadius: "6px",
                            width: "100%",
                            border: " 1px solid #c4c4c4",
                          },
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "transparent",
                          },
                        }}
                        id="Instruction"
                        placeholder={lang.questionPoint}
                        // value={test22Value[section.id] || section.test245 || ""}
                        value={test22Value[section.id] || section.test245 || ""}
//                     value={
//   test22Value.hasOwnProperty(section.id)
//     ? test22Value[section.id]  // use typed value even if empty string
//     : section.test245 ??       // fallback from section if typed doesn't exist
//     allinone.find((item) => item.question_no === section.id)?.points ?? ""
// }
                        onChange={(e) => {
  const newValue = e.target.value;
  setTest22Value((prev) => ({
    ...prev,
    [section.id]: newValue,
  }));
}}
                      />


                    </Box>
                    <Fileupload
                      fileuploadclass="availablityfile"
                      fileuploadstyle={{ border: "1px solid #F1F2F3", borderRadius: "10px", width: "56px", height: "56px", }}
                      iconSrc={galleryadd}
previewImage={uploadedImages[section.id]}
                      onFileSelect={(file) => handleUpload(file, section.id)}
                      previewSize={{ width: 24, height: 24 }}
                      onRemoveFile={() => handleRemove(section.id)}

                    />
                  </Box>

                </Box>
              </Grid>
              <Grid item sx={{ paddingLeft: "34px !important" }} md={1}>
                <Box sx={{ backgroundColor: "#FFF", width: "80px", borderRadius: "10px", padding: "12px", display: "flex", gap: "26px", flexWrap: "wrap", justifyContent: "center", }}>
                  <span
                    draggable
                    onDragStart={() => (clickedItem.current = index)}
                    onDragEnter={() => (cleckedItemHolder.current = index)}
                    onDragEnd={handleSort}
                    onDragOver={handleDragOver}
                    style={{ cursor: "grabbing", color: "#282829", fontSize: "19px", }}>
                    ⋮⋮
                  </span>
                  <Button onClick={() => handleCopy(section.textValue)} sx={{ padding: "0", minWidth: "unset !important" }}><img src={copy} alt="copy" /></Button>
                  <Tooltip title="Delete" arrow>
                    <Button onClick={() => handleDelete(section.id)} sx={{ padding: "0", minWidth: "unset !important" }}><img width={20} height={20} src={trash} alt="trash" />
                    </Button></Tooltip>
                </Box>
              </Grid>

            </Grid>
          ))}
        </Box>
      ) : (
        <Box>
          {currentData.map((section: any, index: any) => (
            <Grid className={combinedqtnclass} key={section.id} container spacing={1}>
              <Grid item md={11}>
                <Box sx={{ padding: "24px", backgroundColor: "#FFF", borderRadius: "16px", marginBottom: "24px", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #F1F2F3", paddingBottom: "18px", marginBottom: "18px", }}>
                    <AddNameBtn
                      initialName={section.initialName}
                      placeholder={section.placeholder}
                      onNameChange={(name: string) => console.log(`Name changed for Section ${section.id}:`, name)}
                      markerImage={section.markerImage}
                    />
                    <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#282829" }}> {section.typographyText} </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "18px", justifyContent: "end", marginBottom: "18px", }}>


                    <TextField
  value={
    activeStep === 1
      ? textValueData.find((item) => item.id === section.id)?.value || ""
      : textValueHiData.find((item) => item.id === section.id)?.value || ""
  }
  onChange={(e) => {
    const newValue = e.target.value;
    if (activeStep === 1) {
      const oldValue = textValueData.find((item) => item.id === section.id)?.value || "";
      setTextValueData((prev) => updateValueById(prev, section.id, newValue));
      const existingHi = textValueHiData.find((item) => item.id === section.id);
      if (!existingHi || existingHi.value.trim() === "" || existingHi.value === oldValue) {
        setTextValueHiData((prev) => updateValueById(prev, section.id, newValue));
      }
    } else if (activeStep === 2) {
      setTextValueHiData((prev) => updateValueById(prev, section.id, newValue));
    }
  }}
  placeholder={section.mainplaceholder}
  sx={{ backgroundColor: "#F9FBFC" }}
  variant="outlined"
/>

                    <Box sx={{ margin: "0 0 0 0px" }}>
                      <TextField
                        sx={{
                          ".MuiInputBase-input": {
                            padding: "16px",
                            color: "#171717",
                            fontSize: "16px",
                            fontWeight: "500",
                            background: "#F9FBFC",
                            borderRadius: "6px",
                            width: "100%",
                            border: " 1px solid #c4c4c4",
                          },
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "transparent",
                          },
                        }}
                        id="Instruction"
                        placeholder={lang.questionPoint}
                         value={test22Value[section.id] || section.test245 || ""}
//                     value={
//   test22Value.hasOwnProperty(section.id)
//     ? test22Value[section.id]  // use typed value even if empty string
//     : section.test245 ??       // fallback from section if typed doesn't exist
//     allinone.find((item) => item.question_no === section.id)?.points ?? ""
// }
                        onChange={(e) => {
  const newValue = e.target.value;
  setTest22Value((prev) => ({
    ...prev,
    [section.id]: newValue,
  }));
}}
                      />


                    </Box>
                {Tabname !== "Image Capture Task" && Tabname !== "छवि कैप्चर कार्य" && (
                    <Box sx={{ position: "relative", width: "200px" }}>
                      <img style={{ position: "absolute", top: "17px", marginLeft: "12px" }} src={note} alt="note" />
                      <Select
                        value={section.selectValue}
                        onChange={(e) => handleSelectChange(e, section.id)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{ width: "100%", ".MuiSelect-select": { padding: "16px 43px 16px 47px!important", fontSize: "16px", fontWeight: "500" }, ".MuiSvgIcon-root": { backgroundImage: `url(${ArrowDownCurve})`, height: "24px", width: "24px", backgroundRepeat: "no-repeat", backgroundSize: "cover", }, ".MuiSvgIcon-root path": { display: "none" } }}
                      >
                        {/* {section.dropdownOptions.map((option: { id: React.Key | null | undefined; value: string | number | readonly string[] | undefined; label: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }) => (
                          <MenuItem key={option.id} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))} */}

                        {section.dropdownOptions.map(
  (option: {
    id: React.Key | null | undefined;
    value: string | number | readonly string[] | undefined;
    label:
      | string
      | number
      | boolean
      | React.ReactElement
      | Iterable<React.ReactNode>
      | React.ReactPortal
      | null
      | undefined;
  }) => {
    // If label is "MCQ Image", show "Image Capture" instead
    const displayLabel =
      option.label === "MCQ Image" ? "Image Capture" : option.label;

    return (
      <MenuItem key={option.id} value={option.value}>
        {displayLabel}
      </MenuItem>
    );
  }
)}

                      </Select>
                    </Box>
                    )}
                    <Fileupload
                      fileuploadclass="availablityfile"
                      fileuploadstyle={{ border: "1px solid #F1F2F3", borderRadius: "10px", width: "56px", height: "56px", }}
                      iconSrc={galleryadd}
previewImage={uploadedImages[section.id]}
                      onFileSelect={(file) => handleUpload(file, section.id)}
                      previewSize={{ width: 24, height: 24 }}
                      onRemoveFile={() => handleRemove(section.id)}

                    />
                  </Box>
                  {Tabname === "Educational task" && (
                    <Box sx={{ margin: "10px 0 20px", width: "300px" }}>
                      <TextField
                        value={
                          activeStep === 1
                            ? textValueData44.find((item) => item.id === section.id)?.value || ""
                            : textValueData44.find((item) => item.id === section.id)?.value !== undefined
                              ? textValueData44.find((item) => item.id === section.id)?.value
                              : textValueData44.find((item) => item.id === section.id)?.value || ""
                        }
                        onChange={(e) => {
                          const newValue = e.target.value;
                          if (activeStep === 1 || activeStep === 2) {
                            setTextValueData44((prev) => updateValueById1(prev, section.id, newValue));
                          }
                        }}
                        placeholder={
                          activeLanguage === "hi"
                            ? "प्रयासों की संख्या"
                            : activeLanguage === "mr"
                              ? "प्रयत्नांची संख्या"
                              : "Number of Attempts"
                        }
                        sx={{ backgroundColor: "#F9FBFC" }}
                        variant="outlined"
                      />
                    </Box>
                  )}
                  {section.selectValue === "instructions" && (<Instruction initialInstructions={section.instructions} placeholderPrefix={lang.instruction} lang={lang} idid={section.id} textvalue={""} multiples={[]} selectedValue={null} text={""} sectionsData1={""} selectedLabel={null} updateSectionsData2={function (sectionId: number, selectedLabel: string | null): void {
                    throw new Error("Function not implemented.");
                  }} />)}
                  {section.selectValue === "" && (<MulitipleChoice initialMultiplies={section.Multiples} index={index} placeholderPrefix={lang.option} lang={lang} idid={section.id} textvalue={section.textValue}
                    sectionsData1={currentData.length}
                    test22={test22}

                    updateSectionsData={updateSectionsData}
                    updateSectionsData1={updateSectionsData1}
                    updateSectionsData345={updateSectionsData345}


                  />)}
                  {section.selectValue === "checkbox" && (<Checkbox initialCheckBoxes={section.Checkboxes} placeholderPrefix={lang.option} lang={lang} idid={section.id} />)}
                  {section.selectValue === "ratings" && (<StarRating initialStars={section.rating.initialStars} maxStarsOptions={section.rating.maxStarsOptions} />)}
                  {/* {section.selectValue === "mcqimage" && (
                <MulitipleChoice
                  initialMultiplies={section.Multiples}
                  index={index}
                  placeholderPrefix={lang.option}
                  lang={lang}
                  idid={section.id}
                  textvalue={section.textValue}
                  sectionsData1={currentData.length}
                  test22={test22}
                  updateSectionsData={updateSectionsData}
                  updateSectionsData1={updateSectionsData1}
                  updateSectionsData345={updateSectionsData345}
                  bannerProps={{
                    title: lang.uploadImage,
                    uploadText: lang.uploadText,
                    uploadSize: lang.uploadSize,
                    imageUrls: uploadedImages[section.id] || "",   // ✅ section-specific image
                    maintitle: "",
                    setuploadedImage: (image: string) => {
                      setUploadedImages((prev) => ({
                        ...prev,
                        [section.id]: image,   // ✅ update only this section
                      }));
                    },
                  }}
                  setIconImage={() => { }}
                  iconImage=""
                />
              )} */}
                  {/* {section.selectValue === "longshortdescription" && (
                <Box sx={{ mt: 2, display: "grid", gap: 2 }}>
                  <TextField
                    multiline
                    minRows={4}
                    placeholder={activeStep === 1 ? "Long description" : "Long description (Hindi)"}
                    value={
                      activeStep === 1
                        ? longDescriptions[section.id] || section.longShortDescription?.long || ""
                        : longDescriptionsHi[section.id] || longDescriptions[section.id] || section.longShortDescription?.long_hi || section.longShortDescription?.long || ""
                    }
                    onChange={(e) => handleLongChange(section.id.toString(), e.target.value)}
                  />
                </Box>
              )} */}

                  {/* <Box className="task_img_upload">
                    <ImageUploadBanner title={lang.uploadImage} uploadText={lang.uploadText} uploadSize={lang.uploadSize} imageUrls={""} setuploadedImage={setuploadedImage}  lang={lang} />
                  </Box> */}

                </Box>
              </Grid>
              <Grid item sx={{ paddingLeft: "34px !important" }} md={1}>
                <Box sx={{ backgroundColor: "#FFF", width: "80px", borderRadius: "10px", padding: "12px", display: "flex", gap: "26px", flexWrap: "wrap", justifyContent: "center", }}>
                  <span
                    draggable
                    onDragStart={() => (clickedItem.current = index)}
                    onDragEnter={() => (cleckedItemHolder.current = index)}
                    onDragEnd={handleSort}
                    onDragOver={handleDragOver}
                    style={{ cursor: "grabbing", color: "#282829", fontSize: "19px", }}>
                    ⋮⋮
                  </span>
                  <Button onClick={() => handleCopy(section.textValue)} sx={{ padding: "0", minWidth: "unset !important" }}><img src={copy} alt="copy" /></Button>
                  <Tooltip title="Delete" arrow>
                    <Button onClick={() => handleDelete(section.id)} sx={{ padding: "0", minWidth: "unset !important" }}><img width={20} height={20} src={trash} alt="trash" />
                    </Button></Tooltip>
                </Box>
              </Grid>

            </Grid>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default QuestionsBox;